// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__LbJBp","header":"ReportDetails_header__2x_ho","title":"ReportDetails_title__10fDs","left":"ReportDetails_left__2mKGe"};